const LoaderPage = () => {
    return (
        <div className='loadingPageContainer'>
            <span>Please wait</span>
            <div class="loaderDots"></div>
        </div>
    )
}

export default LoaderPage